/** A generic component template that transcludes its content. */
export const TranscludeComponent = {
    transclude: true,
    replace: true,
    template: `<ng-transclude></ng-transclude>`
}
